import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TranscodeService {

  private apiUrl = environment.trackycontrol;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getTranscodes(domain: string): Observable<any> {
    const token = this.authService.getToken();
    if (!token) {
      return throwError(() => new Error('Missing auth token'));
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    const params = {
      'domain.equals': domain,
      'valid.equals': 'true',
      'page': '0',
      'size': '10000'
    };

    return this.http.get<any>(`${this.apiUrl}/api/transcodes`, { headers, params });
  }
}